/** @module csi/slicer/slicerCompareDlg */
define([
	"dojo/_base/declare",
	"dojo/dom-class",
	"dijit/registry",
	"csi/_base/underscore",
	"csi/html",
	"csi/locale",
	"csi/view/ViewDialog",
	"csi/widget/CheckBox",
	"csi/widget/FilteringSelect",
	"csi/widget/InvalidMessage",
	"csi/widget/RadioButton"
], function(declare,domClass,registry,_,html,locale,ViewDialog,CheckBox,FilteringSelect,InvalidMessage,RadioButton) {

	/** Options for color select */
	return declare(ViewDialog,{
		bSubmitOnEnter: true,
		dialogActions: true,
		destroyOnHide: true,
		'class':'csi-slicer-dlg',

		/**
		 * @property {InvalidMessage} invalidMessage
		 */
		invalidMessage: null,

		/**
		 * @property {DomNode} compareToValNode
		 */
		compareToValNode: null,

		/**
		 * @property {DomNode} rbCompareToValNode
		 */
		rbCompareToValNode: null,

		/**
		 * @property {domNode} lblComparToValue,
		 */
		lblComparToValue: null,

		/**
		 * @property {RadioButton} rbCompareTo,
		 */
		rbCompareTo: null,

		/**
		 * @property {RadioButton} rbCompareToVal,
		 */
		rbCompareToVal: null,

		/**
		 * @property {FilteringSelect} compareTo,
		 */
		selCompareTo: null,

		/**
		 * @property {FilteringSelect} compareToVal,
		 */
		selCompareToVal: null,

		/** @property {Memory} _firstColClsValuesStore - {id, name} of first column classifier values. Used for Compare Dialog */
		firstColClsValuesStore: null,

		/** @property {Memory} _colClsNamesStore - {id, name} of column classifiers. Used for Compare Dialog */
		colClsNamesStore:null,

		postCreate: function(){
			this.renderDlg();

			this.inherited(arguments);
		},

		/**
		 * Focus primary button
		 */
		onRenderDialogActions: function(div){
			registry.byNode(div.firstChild).focusNode.tabIndex = 1;
		},

		/**
		 * Render Dialog
		 */
		renderDlg: function(){
			var self = this;
			var compareToVal = this.cfg.val;
			var bPercent = this.cfg.bPercent;
			var node = html.create('div',{'class':'csi-slicer-dlg-cont'}, this.containerNode, "before");
			this.invalidMessage = new InvalidMessage().placeAt(node);
			// table
			var table = html.create('div',{'class':'csi-slicer-table'}, node);
			var row;
			var cell;

			// row 1 - Select Classifier
			row = html.create('div',{'class':'csi-slicer-row'}, table);
			// cell 1
			cell = html.create('div',{'class':'csi-slicer-cell'}, row);
			html.create('span',{innerText: locale.resource('SlicerSelectClassifier')}, cell);
			// cell 2
			cell = html.create('div',{'class':'csi-slicer-cell'}, row);
			this.selCompareTo = new FilteringSelect({store: this.colClsNamesStore, required: true, value: this.cfg.key, onChange: function(val){
				self._setCompareToValVisible();
			}}).placeAt(cell);

			// row 2 - Compare To - To Previous
			row = html.create('div',{'class':'csi-slicer-row'}, table);

			//cell 1
			cell = html.create('div',{'class':'csi-slicer-cell'}, row);
			html.create('span',{innerText:locale.resource('SlicerCompareTo')}, cell);
			// cell 2
			cell = html.create('div',{'class':'csi-slicer-cell'}, row);
			this.rbCompareTo = new RadioButton({name: 'compareRadio', id: 'cbComparePrevious', value: 'previous', checked: !compareToVal}).placeAt(cell);
			html.create('label',{'for':'cbComparePrevious', innerText:locale.resource('SlicerToPrevious')}, cell);

			// row 3 - To Specific
			row = html.create('div',{'class':'csi-slicer-row'}, table);
			// cell 1
			html.create('div',{'class':'csi-slicer-cell'}, row);
			this.rbCompareToValNode = cell = html.create('div',{'class':'csi-slicer-cell'}, row);
			// cell 2
			this.rbCompareToVal = new RadioButton({name: 'compareRadio', id: 'cbCompareSpecific', label: 'label', value: 'specific', checked: compareToVal, onChange: function(val){
				self._setCompareToValVisible();
			}}).placeAt(cell);
			this.lblCompareToVal = html.create('label',{'for':'cbCompareSpecific', innerText:locale.resource('SlicerToSpecific')}, cell);

			// row 4 - Select Value for "Compare to Specific"
			this.compareToValNode = row = html.create('div',{'class':'csi-slicer-row'}, table);
			// cell 1
			cell = html.create('div',{'class':'csi-slicer-cell'}, row);
			html.create('span',{innerText: locale.resource('SlicerSelectValue')}, cell);
			// cell 2
			cell = html.create('div',{'class':'csi-slicer-cell'}, row);
			this.selCompareToVal = new FilteringSelect({store: this.firstColClsValuesStore, required: true, value: this.cfg.val}).placeAt(cell);
			this._setCompareToValVisible();

			// row 5 - Calculate Percentage
			row = html.create('div',{'class':'csi-slicer-row'}, table);

			//cell 1
			cell = html.create('div',{'class':'csi-slicer-cell'}, row);
			html.create('span',{innerText:locale.resource('SlicerCompareCalcPercentage')}, cell);
			// cell 2
			cell = html.create('div',{'class':'csi-slicer-cell'}, row);
			this.cbCalcPercent = new CheckBox({name: 'calcPercent', id: 'cbCalcPercent', checked: bPercent}).placeAt(cell);

			if (this.colClsNamesStore.data.length == 0) {
				this.invalidMessage.set('value', locale.resource("SlicerCmpNoColCls"));
			}
		},


		/**
		 * Update visibility of CompareToVal row
		 */
		_setCompareToValVisible: function(){
			var firstClsSelected = (this.metricsPos > 0) && this.colClsNamesStore.data.length && (this.selCompareTo.value == this.colClsNamesStore.data[0].id);
			if (!firstClsSelected){
				this.rbCompareTo.set('checked', true);
				this.rbCompareToValNode.title = locale.resource('SlicerCmpValDisabledReason');
			} else {
				this.rbCompareToValNode.title = '';
			}
			this.rbCompareToVal.set('disabled', !firstClsSelected);
			domClass.toggle(this.lblCompareToVal, 'csi-disabled', !firstClsSelected);
			var visible = this.rbCompareToVal.checked;
			html.setVisible(this.compareToValNode, visible);
		},

		/**
		 * Validate data and get new values if data is valid
		 * @return {boolean} - true if valid
		 */
		validate: function(){
			var res = this._validate();
			if (res){
				this.updateValue();
			}
			return res;
		},

		/**
		 * Validate our data
		 * @return {boolean} - true if valid
		 */
		_validate: function(){
			var res = true;
			this.invalidMessage.set('value', '');
			if (!this.selCompareTo.isValid()){
				this.selCompareTo.focus();
				res = false;
			}
			if (this.rbCompareToVal.checked && !this.selCompareToVal.isValid()){
				this.selCompareToVal.focus();
				res = false;
			}
			if (!res){
				this.invalidMessage.set('value', locale.resource("RequiredValue"));
			}
			return res;
		},

		/**
		 * Retrieve data from controls
		 */
		updateValue: function(){
			this.cfg.key = this.selCompareTo.value;
			this.cfg.val = this.rbCompareToVal.checked ? this.selCompareToVal.value : null;
			this.cfg.bPercent = this.cbCalcPercent.checked;
		},

		/**
		 * Overwrite default function to make "onSave" always works. We use our own validation methods.
		 * @return {boolean} - always return true
		 */
		_hasValueChanged: function(){
			return true;
		}
	});
});
